<template>
  <v-container>
    <v-tab-item class="pb-12">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('secondStepAvailable', $event)" />

        <div class="text-center display-1 font-weight-normal mb-6">
          Vamos começar preenchendo as informações básicas
        </div>
        <v-row class="mx-auto">
          <v-col cols="12">
            <v-alert
              dense
              outlined
              type="info"
              color="blue"
              class="mb-4 py-0 px-1"
            >
              NÃO são utilizadas as TIs: 10 a 29, 70 a 92, 94, 95, 97 a 99.
            </v-alert>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                id="titulo-comparativo"
                label="Título"
                outlined
                v-model="campos.titulo"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mx-auto" id="data-imobilizacao-comparativo">
          <v-col cols="5">
            <v-menu
              v-model="menuPickerImobInicio"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider 
                  v-slot="{ errors }"
                  :rules="{required_if: campos.dataFormattedImobFim != null && campos.dataFormattedImobFim.length > 0, min:10}"
                >
                  <v-text-field
                    :error-messages="errors"
                    class="pt-0"
                    v-mask="'##/##/####'"
                    v-model="campos.dataFormattedImobInicio"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobInicio = parseDate(campos.dataFormattedImobInicio);"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobInicio"
                @input="menuPickerImobInicio = false; campos.dataFormattedImobInicio = formatDate(campos.dataImobInicio);"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
          <v-col class="text-center pt-6" style="min-width:60px !important;" cols="1">
            <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
          </v-col>
          <v-col cols="5">
            <v-menu
              v-model="menuPickerImobFim"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider 
                  v-slot="{ errors }"
                  :rules="{required_if: campos.dataFormattedImobInicio != null && campos.dataFormattedImobInicio.length > 0, min:10}"
                >
                  <v-text-field
                    :error-messages="errors"
                    class="pt-0"
                    v-mask="'##/##/####'"
                    v-model="campos.dataFormattedImobFim"
                    label="Data Imobilização"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.dataImobFim = parseDate(campos.dataFormattedImobFim);"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="campos.dataImobFim"
                @input="menuPickerImobFim = false; campos.dataFormattedImobFim = formatDate(campos.dataImobFim);"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
        </v-row>
        <div id="group-check-comparativo">
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox
                class="mt-0"
                v-model="campos.anual"
                label="Comparar por ano"
                checked
              />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col class="pb-0" cols="12">
              <v-checkbox
                class="mt-0 pt-0"
                v-model="campos.comparaTi"
                label="Comparar por TI"
              />
            </v-col>
          </v-row>
          <v-row class="mx-auto spacing-checkbox-sig-r">
            <v-col cols="12">
              <v-checkbox
                class="mt-0 pt-0"
                v-model="campos.sobraFisica"
                label="Incluir Todas as Situações Contábeis (SITCONT)"
              />
            </v-col>
          </v-row>
        </div>
      </validation-observer>
    </v-tab-item>

    <v-tab-item class="pb-0">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('thirdStepAvailable', $event)" />

        <div class="text-center display-1 font-weight-normal mb-6">
          Qual a origem do AIS e tipo do SIG-R?
        </div>
        <v-row align="center" class="mx-auto" id="group-tipo-comparativo">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-radio-group
                @change="campos.bdgd == true ? campos.origemAis = 'BANCO DE DADOS' : campos.origemAis = campos.origemAis"
                v-model="campos.bdgd"
                :error-messages="errors"
                row
                class="pt-0 mt-0"
              >
                <v-radio
                  label="SIG-R Completa"
                  :value="false"
                />
                <v-radio
                  label="Apenas BDGD"
                  :value="true"
                />
              </v-radio-group>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row v-if="!campos.bdgd" align="center" class="mx-auto" id="origem-ais-comparativo">
          <v-col class="pb-0" cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                no-gutters
                v-model="campos.origemAis"
                outlined
                :items="['BANCO DE DADOS', 'ARQUIVO']"
                label="Origem AIS"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <div id="csv-ais-comparativo">
          <v-row align="center" class="mx-auto" v-if="campos.origemAis === 'ARQUIVO'">
            <v-col class="pb-0" cols="12">
              <template>
                <v-alert
                  dense
                  outlined
                  type="info"
                  color="blue"
                  class="mb-4 py-0 px-1"
                >
                  <div v-if="campos.anual && campos.comparaTi">
                    O arquivo selecionado deve conter os campos: <b>ODI, TI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, DATA_IMOBILIZACAO, UAR_PRINCIPAL.</b>
                  </div>
                  <div v-else-if="campos.anual && !campos.comparaTi">
                    O arquivo selecionado deve conter os campos: <b>ODI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, DATA_IMOBILIZACAO, UAR_PRINCIPAL.</b>
                  </div>
                  <div v-else-if="!campos.anual && campos.comparaTi">
                    O arquivo selecionado deve conter os campos: <b>ODI, TI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, UAR_PRINCIPAL.</b>
                  </div>
                  <div v-else>
                    O arquivo selecionado deve conter os campos: <b>ODI, TUC, A1, A2, A3, A4, A5, A6, QTD, DATA_BASE, UAR_PRINCIPAL.</b>
                  </div>
                  <div class="pt-1">Obs¹: Os campos do tipo data precisão estar no formato brasileiro: xx/xx/xxxx.</div>
                  <div class="pt-1">Obs²: O campo QTD pode conter o nome de QTD Somatório ou QTD para ser validado.</div>
                </v-alert>
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-file-input
                    @change="uploadNewFile()"
                    class="input-upload-csv"
                    label="Base AIS CSV"
                    placeholder="Selecione um arquivo CSV"
                    outlined
                    accept=".csv, .zip"
                    v-model="arquivo"
                    :show-size="!fakeFileFound"
                    truncate-length="30"
                    :loading="uploadInProgress"
                    loader-height="4"
                    :success="arquivoId && arquivo ? true : false"
                    :error-messages="errors"
                  />
                </validation-provider>
                <!-- Validar se o upload do arquivo foi concluido -->
                <validation-provider rules="required">
                  <input type="hidden" name="validateUpload" :value="arquivoId" />
                </validation-provider>
              </template>
            </v-col>
          </v-row>
          <v-row align="center" class="mx-auto" v-if="campos.origemAis === 'ARQUIVO'">
            <v-col class="pl-0" cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field label="Delimitador" outlined v-model="campos.arquivoDelimitador" :error-messages="errors" />
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field label="Invólucro" outlined v-model="campos.arquivoInvolucro" :error-messages="errors" />
              </validation-provider>
            </v-col>
            <v-col class="pr-0" cols="12" sm="4">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field label="Escape" outlined v-model="campos.arquivoEscape" :error-messages="errors" />
              </validation-provider>
            </v-col>
          </v-row>
        </div>
        <v-row align="center" class="mx-auto" id="data-base-bdgd-ais-comparativo">
          <v-col cols="5">
            <v-menu
              v-model="menuPickerBdgd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    :error-messages="errors"
                    class="pt-0"
                    type="tel" v-mask="'##/####'"
                    v-model="campos.monthFormattedBdgd"
                    label="Data Base BDGD"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.monthBdgd = parseMonth(campos.monthFormattedBdgd);"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                type="month"
                v-model="campos.monthBdgd"
                @input="menuPickerBdgd = false; campos.monthFormattedBdgd = formatMonth(campos.monthBdgd);"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
          <v-col cols="1" />
          <v-col cols="5" v-if="!campos.bdgd">
            <v-menu
              v-if="campos.origemAis == 'BANCO DE DADOS'"
              v-model="menuPickerAis"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <validation-provider v-slot="{ errors }" rules="required|min:7">
                  <v-text-field
                    :error-messages="errors"
                    class="pt-0"
                    type="tel" v-mask="'##/####'"
                    v-model="campos.monthFormattedAis"
                    label="Data Base AIS"
                    prepend-icon="mdi-calendar"
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @blur="campos.monthAis = parseMonth(campos.monthFormattedAis);"
                  />
                </validation-provider>
              </template>
              <v-date-picker
                type="month"
                v-model="campos.monthAis"
                @input="menuPickerAis = false; campos.monthFormattedAis = formatMonth(campos.monthAis);"
                locale="pt-br"
              />
            </v-menu>
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>

    <v-tab-item class="pb-12">
      <validation-observer v-slot="{ valid }">
        <validation-helper :interceptor="valid" @isValid="$emit('btnFinishAvailable', $event)" />

        <div class="text-center display-1 font-weight-normal mb-6">
          Para finalizar, preencha as TUCs e ODIs para comparação
        </div>
        <v-row align="center" class="mx-auto" id="tucs-comparativo">
          <v-col cols="12">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                :error-messages="errors"
                v-model="campos.tucsSelected"
                :items="campos.tucs"
                item-value="id"
                item-text="nome"
                label="TUCs"
                multiple
                outlined
                chips
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row align="center" class="mx-auto" id="odis-comparativo">
          <v-col cols="12">
            <v-textarea
              label="ODis"
              placeholder="Insira os códigos das ODis, um código por linha"
              rows="5"
              no-resize
              clearable
              clear-icon="mdi-close-circle"
              v-model="campos.odis"
            />
          </v-col>
        </v-row>
      </validation-observer>
    </v-tab-item>
  </v-container>
</template>

<script>
import ArquivosService from "@/services/ArquivosService.js";
import ConfiguracoesService from "@/services/ConfiguracoesService.js";
import TabelasService from '@/services/TabelasService';
import dateFormatterMixins from "@/mixins/dateFormatterMixins";

export default {
  components: {
    ValidationHelper: () => import("@/components/general/ValidationHelper.vue"),
  },

  mixins: [dateFormatterMixins],

  props: {
    items: {
      type: Object,
      default: ()=> {}
    },
    tucs: {
      type: Array,
      default: ()=> []
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.fillFields();
    } else {
      this.getParamsArquivoCsv();
      this.getUltimaDataBase();
    }
  },

  data() {
    return {
      menuPickerAis: false,
      menuPickerBdgd: false,
      menuPickerImobInicio: false,
      menuPickerImobFim: false,
      campos: {
        titulo: '',
        origemAis: 'BANCO DE DADOS',
        monthFormattedAis: '',
        monthAis: '',
        monthFormattedBdgd: '',
        monthBdgd: '',
        dataFormattedImobInicio: '',
        dataImobInicio: '',
        dataFormattedImobFim: '',
        dataImobFim: '',
        sobraFisica: false, /* True = SITCONT (checked) */
        bdgd: false, /* False = SIG-R Completa, True = Apenas BDGD */
        comparaTi: false,
        anual: true, /* True = Comparar por ano (checked) */
        tucs: ['125','160','210','295','340','345','565','570','575','580'],
        tucsSelected: ['125','160','210','295','340','345','565','570','575','580'],
        odis: '',
        arquivoDelimitador: ';',
        arquivoInvolucro: '"',
        arquivoEscape: '"'
      },
      uploadInProgress: false,
      arquivo: undefined,
      arquivoId: "",
      fakeFileFound: false,
    };
  },

  methods: {
    fillFields() {
      let comparativo = this.items;
      this.campos = {
        titulo: comparativo.titulo,
        bdgd: comparativo.bdgd,
        origemAis: comparativo.origem_ais == 'BANCO' ? 'BANCO DE DADOS' : comparativo.origem_ais,
        comparaTi: comparativo.compara_ti,
        monthFormattedAis: comparativo.data_ais ? this.formatMonth(comparativo.data_ais) : '',
        monthAis: comparativo.data_ais ? this.formatMonthToPicker(comparativo.data_ais) : '',
        monthFormattedBdgd: comparativo.data_bdgd ? this.formatMonth(comparativo.data_bdgd) : '',
        monthBdgd: comparativo.data_bdgd ? this.formatMonthToPicker(comparativo.data_bdgd) : '',
        dataFormattedImobInicio: comparativo.data_imobilizacao_inicio ? this.formatDate(comparativo.data_imobilizacao_inicio) : '',
        dataImobInicio: comparativo.data_imobilizacao_inicio ? this.formatDateToPicker(comparativo.data_imobilizacao_inicio) : '',
        dataFormattedImobFim: comparativo.data_imobilizacao_fim ? this.formatDate(comparativo.data_imobilizacao_fim) : '',
        dataImobFim: comparativo.data_imobilizacao_fim ? this.formatDateToPicker(comparativo.data_imobilizacao_fim) : '',
        anual: comparativo.anual,
        comparaTi: comparativo.compara_ti,
        sobraFisica: comparativo.sobra_fisica,
        tucs: this.campos.tucs,
        tucsSelected: this.tucs ? this.tucs : [],
        odis: comparativo.odis ? this.formatTextAreaValue(comparativo.odis) : ''
      }

      if (comparativo.arquivo_delimitador != null) {
        this.arquivoId = comparativo.arquivo_id;
        this.campos.arquivoDelimitador = comparativo.arquivo_delimitador;
        this.campos.arquivoInvolucro = comparativo.arquivo_involucro;
        this.campos.arquivoEscape = comparativo.arquivo_escape;
        this.setFakeFileForValidation(); /* Cria um arquivo fake temporario, serve apenas para passar pela validação */
      } else {
        this.getParamsArquivoCsv();
      }
    },

    formatTextAreaValue(valueString) {
      let value = valueString.substring(1, valueString.length - 1);
      return value.replace(/,/g,'').replace(/''/g,"\n");
    },

    uploadNewFile() {
      if (!this.arquivo) return;

      this.arquivoId = "";
      this.uploadInProgress = true;

      let data = new FormData();
      data.append("file", this.arquivo);

      ArquivosService.uploadFile(data)
        .then(response => {
          this.arquivoId = response.data.arquivoId;
          this.fakeFileFound = false;
        })
        .catch(err => {
          console.error(err);
          
          if(err?.data?.cod_erro == 10000) {
            let msg = "Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.";
            this.$toast.error(msg,  "", { position: "topRight", timeout: 8000 });
          } else {
            this.$toast.error("Erro no upload do arquivo.", "", { position: "topRight" });
          }

          this.arquivo = undefined;
        })
        .finally(() => {
          this.uploadInProgress = false;
        });
    },

    getParamsArquivoCsv() {
      ConfiguracoesService.getCsvCamposPadroes()
        .then(response => {
          this.campos.arquivoDelimitador = response.data.campos.delimitador.valor;
          this.campos.arquivoInvolucro = response.data.campos.involucro.valor;
          this.campos.arquivoEscape = response.data.campos.escape.valor;
        })
        .catch(err => {
          console.error("Erro ao recuperar campos padrões do arquivo csv: ", err);
          this.$toast.error("Erro ao recuperar campos padrões do arquivo csv.", "", { position: "topRight" });
        });
    },

    setFakeFileForValidation() {
      ArquivosService.getNameArquivoById(this.arquivoId).then(response => {
        this.arquivo = new File([""], response.data.nome, { type: "text/csv"});
        this.fakeFileFound = true;
      })
      .catch(err => {
        console.error("Erro ao recuperar arquivo csv: ", err);
        this.$toast.error("Erro ao recuperar arquivo csv.", "", { position: "topRight" });
      });
    },

    getUltimaDataBase() {
      return TabelasService.getTabelaResumo()
        .then(response => {
          let data = response.data.tabela_resumo;
          
          this.campos.monthAis = data.data_base_ais ? data.data_base_ais : '';
          this.campos.monthBdgd = data.data_base_bdgd ? data.data_base_bdgd : '';
          this.campos.monthFormattedAis = data.data_base_ais ? this.formatMonth(data.data_base_ais+'-01') : '';
          this.campos.monthFormattedBdgd = data.data_base_bdgd ? this.formatMonth(data.data_base_bdgd+'-01') : '';
        })
        .catch(err => {
          this.$toast.error("Erro ao tentar pegar última data base", "", { position: "topRight"});
          console.error("Erro:", err);
        });
    },

    exportData() {
      if (this.campos.bdgd) { /* IF para caso a opção 'Apenas BDGD' estiver marcada */
        this.campos.monthAis = null;
      }

      return {
        titulo: this.campos.titulo,
        origem_ais: this.campos.origemAis == 'BANCO DE DADOS' ? 'BANCO' : this.campos.origemAis,
        data_bdgd: this.campos.monthBdgd+'-01',
        data_ais: this.campos.monthAis ? this.campos.monthAis+'-01' : null,
        data_imobilizacao_inicio: this.campos.dataImobInicio ? this.campos.dataImobInicio : null,
        data_imobilizacao_fim: this.campos.dataImobFim ? this.campos.dataImobFim : null,
        sobra_fisica: this.campos.sobraFisica,
        bdgd: this.campos.bdgd,
        compara_ti: this.campos.comparaTi,
        anual: this.campos.anual,
        tucs: this.campos.tucsSelected.toString(),
        odis: this.campos.odis,
        arquivo_id: this.campos.origemAis == "ARQUIVO" ? this.arquivoId : null,
        arquivo_delimitador: this.campos.origemAis == "ARQUIVO" ? this.campos.arquivoDelimitador : null,
        arquivo_involucro: this.campos.origemAis == "ARQUIVO" ? this.campos.arquivoInvolucro: null,
        arquivo_escape: this.campos.origemAis == "ARQUIVO" ? this.campos.arquivoEscape : null
      };
    },

    exportTypeTour() {
      return this.campos.bdgd ? 'apenas bdgd' : this.campos.origemAis.toLowerCase(); /* this.campos.bdgd == Apenas BDGD (checked) */
    }
  },
  
  watch: {
    items() {
      this.fillFields();
    }
  }
};
</script>

<style>
  .spacing-checkbox-sig-r div div .v-input__slot {
    margin-bottom: -12px !important;
  }
  .v-alert__icon {
    align-self: center;
  }
</style>